import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import ModalOverlay from '../ui/ModalOverlay';
import ImageModelPicker, { defaultImageModel } from '../image/ImageModelPicker';

type Props = {
  open: boolean;
  prompt?: string;
  onConfirm: (imageModelId: string) => void;
  onClose: () => void;
};

export default function EditorImageModelModal({ open, prompt, onConfirm, onClose }: Props) {
  const [imageModelId, setImageModelId] = useState(defaultImageModel().id);

  useEffect(() => {
    if (open) setImageModelId(defaultImageModel().id);
  }, [open]);

  if (!open) return null;

  return (
    <ModalOverlay onClose={onClose} closeOnBackdrop={false}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 400, width: 'min(400px, calc(100vw - 32px))' }}
      >
        <div className="modal-header">
          <h2 style={{ fontSize: '1.05rem' }}>Modelo de imagem</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        <p style={{ margin: '0 0 14px', fontSize: '0.78rem', color: 'rgba(255,255,255,0.62)', lineHeight: 1.45 }}>
          {prompt || 'Escolha o modelo. O preço da imagem aparece ao lado — o chat (tokens) é separado.'}
        </p>
        <ImageModelPicker value={imageModelId} onChange={setImageModelId} compact />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8,
              background: 'transparent', color: 'rgba(255,255,255,0.7)',
              fontSize: '0.75rem', padding: '8px 12px', cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Agora não
          </button>
          <button
            type="button"
            onClick={() => onConfirm(imageModelId)}
            style={{
              border: 'none', borderRadius: 8, background: '#6366f1', color: '#fff',
              fontSize: '0.75rem', padding: '8px 14px', cursor: 'pointer',
              fontFamily: 'inherit', fontWeight: 600,
            }}
          >
            Continuar
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
